import { render } from "./DonationForm.vue?vue&type=template&id=b035aebc&scoped=true"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"

import "./DonationForm.vue?vue&type=style&index=0&id=b035aebc&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b035aebc"]])

export default __exports__